import './custom-element-shim';



// WEBPACK FOOTER //
// ./src/polyfills.ts